// extracted by mini-css-extract-plugin
export var bounce = "_kl-1";
export var generatingText = "_kl-6";
export var lightning = "_kl-4";
export var popup = "_kl-5";
export var progressBar = "_kl-7";
export var progressFill = "_kl-8";
export var progressShimmer = "_kl-9";
export var progressText = "_kl-a";
export var shimmer = "_kl-3";
export var uploadIcon = "_kl-0";
export var uploadingText = "_kl-2";